import { Container, VictoryModal } from "./styles";
import { useAuth } from "../../providers/Auth";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import parse from "html-react-parser";

const Battle = () => {
  const { battleInfo, handleAttack, uLife, eLife } = useAuth();
  const [gameOver, setGameOver] = useState(false);
  const { findUser, user } = useAuth();
  const token = localStorage.getItem("@game:accessToken") || "";
  const [userPercent, setUserPercent] = useState(
    (100 * battleInfo.char?.status.hp) / uLife
  );
  const [enemyPercent, setEnemyPercent] = useState(
    (100 * battleInfo.enemy?.status.hp) / eLife
  );
  const history = useHistory();

  useEffect(() => {
    if (battleInfo.char.status.hp) {
      setUserPercent((100 * battleInfo.char.status.hp) / uLife);
      setEnemyPercent((100 * battleInfo.enemy.status.hp) / eLife);
    }
  }, [battleInfo.char.status.hp, battleInfo.enemy.status.hp, uLife, eLife]);

  useEffect(() => {
    if (battleInfo.char.status.hp <= 0 || battleInfo.enemy.status.hp <= 0) {
      setGameOver(true);
    }
  }, [battleInfo.char.status.hp, battleInfo.enemy.status.hp]);

  return (
    <Container className="rpgui-content">
      <div className="rpgui-container framed-golden-2 user-card">
        <h3>{battleInfo.char.name}</h3>
        <div className="rpgui-progress  ">
          <div className="rpgui-progress-left-edge"></div>
          <div className="rpgui-progress-track">
            <div
              className="rpgui-progress-fill red"
              style={{
                width: `${userPercent}%`,
              }}
            ></div>
          </div>

          <div className="rpgui-progress-right-edge"></div>
        </div>
      </div>
      <img
        src={battleInfo.char.sprite.url}
        alt="user"
        className="user-sprite"
      />

      <div className="rpgui-container framed-golden-2 enemy-card">
        <h3>{battleInfo.enemy.name}</h3>
        <div className="rpgui-progress  ">
          <div className="rpgui-progress-left-edge"></div>
          <div className="rpgui-progress-track">
            <div
              className="rpgui-progress-fill red"
              style={{
                width: `${enemyPercent}%`,
              }}
            ></div>
          </div>

          <div className="rpgui-progress-right-edge"></div>
        </div>
      </div>
      <img
        src={battleInfo.enemy.sprite.url}
        alt="enemy"
        className="enemy-sprite"
      />
      <div>
        <section className="rpgui-container framed status">
          <h1>Battle Status:</h1>
          {battleInfo.msg &&
            battleInfo.msg.battleStatus.map((item: any) => (
              <p key={item}>
                {parse(`${typeof item === "string" ? item : ""}`)}
              </p>
            ))}
        </section>
        <section className="rpgui-container framed actions">
          <h1>Attacks:</h1>
          {battleInfo.char.attacks.map((attack: any) => (
            <div className="rpgui-container framed-golden atk">
              <div>
                <p className="attack-tittle">{attack.name}</p>
                <p>type: {attack.type}</p>
                <p>power: {attack.power}</p>
                <p>hits: {attack.hits}</p>
                <p>accuracy: {attack.accuracy}</p>
              </div>
              <button
                onClick={() => {
                  handleAttack(attack.id, token);
                  setUserPercent((100 * battleInfo.char.status.hp) / uLife);
                  setEnemyPercent((100 * battleInfo.enemy.status.hp) / eLife);
                }}
              >
                <p>Attack!</p>
              </button>
            </div>
          ))}
        </section>
      </div>
      {gameOver && (
        <VictoryModal className="rpgui-content">
          <div className="rpgui-container framed-golden">
            <h1>{battleInfo.msg.result}</h1>
            <section>
              {battleInfo.msg &&
                battleInfo.msg.battleStatus.map((item: any) => (
                  <p key={item}>
                    {parse(`${typeof item === "string" ? item : ""}`)}
                  </p>
                ))}
            </section>
            <div>
              <button
                className="rpgui-button"
                onClick={() => history.push("/map")}
              >
                <p>Map</p>
              </button>
              <button
                className="rpgui-button"
                onClick={() => {
                  history.push("/dashboard");
                  findUser(user.id, token);
                }}
              >
                <p>Dashboard</p>
              </button>
            </div>
          </div>
        </VictoryModal>
      )}
    </Container>
  );
};

export default Battle;
